import axios from 'axios';

const getExtraParameterByQuery = (clientId: number, includeInactive: boolean ) => 
    axios.get(`clients/${clientId}/extra-parameters?includeInactive=${includeInactive}`);

export default {
    getExtraParameterByQuery
};

